import { render, staticRenderFns } from "./QnaClsMgmt.vue?vue&type=template&id=1591af14&"
import script from "./QnaClsMgmt.vue?vue&type=script&lang=js&"
export * from "./QnaClsMgmt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports